<div class="inner-page-bg-right">
  <header data-aos="zoom-in">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="inner-header">
            <div class="logo">
              <a href="javascript:void();" [routerLink]="'/login'"> <img src="./assets/images/logo-inner.png" alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <section class="banner-inner-pages">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-7 col-lg-5 left-panel">
          <div class="banner-left-text">
            <h1 data-aos="fade-up">Forgot your password?</h1>
          </div>
          <h4 class="mt-5">Please enter the email address associated with your account and We will email you a link to
            reset your
            password.</h4>
          <form [formGroup]="loginForm" class="form-container" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="row mb-2">
              <div class="col-sm-12">
                <mat-form-field appearance="outline">
                  <mat-label>Email Adddress</mat-label>
                  <input matInput formControlName="email" oninput="this.value = this.value.toLowerCase()"
                    placeholder="Email ID" type="email">
                  <mat-error *ngIf="submitted && f.email.errors?.required" class="invalid-feedback">
                    Email Adddress is required
                  </mat-error>
                  <mat-error *ngIf="submitted && f.email.errors?.pattern" class="invalid-feedback">
                    Please enter valid Email Adddress
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <button type="submit" mat-raised-button color="primary">Submit</button>
            <button type="button" class="mx-2" mat-raised-button color="" (click)="onClickBack()">Back to
              Login</button>
          </form>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-7 signup-img"> <img src="./assets/images/signup-1.png" alt="">
        </div>
      </div>
    </div>
  </section>
</div>
<app-admin-footer></app-admin-footer>